import { render, staticRenderFns } from "./wagesDetailList.vue?vue&type=template&id=703c5801&scoped=true&"
import script from "./wagesDetailList.vue?vue&type=script&lang=js&"
export * from "./wagesDetailList.vue?vue&type=script&lang=js&"
import style0 from "./wagesDetailList.vue?vue&type=style&index=0&id=703c5801&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703c5801",
  null
  
)

export default component.exports